module.exports = __webpack_public_path__ + "img/ff2-min.jpg";